import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { map, tap, catchError } from 'rxjs/operators';
import { InvestigationsRepository } from '../../../infrastructure/repositories/investigations.repository';
import { InvestigationsState } from '../../states/investigations.state';
import { InvestigationAttachmentEntity } from '../../../domain/entities/investigation-attachment.entity';

export interface GetInvestigationAttachmentsQuery { investigationId: string; }
export interface GetInvestigationAttachmentsResult { attachments: InvestigationAttachmentEntity[]; }

@Injectable({ providedIn: 'root' })
export class GetInvestigationAttachmentsUseCase {
  private readonly _repository = inject(InvestigationsRepository);
  private readonly _state = inject(InvestigationsState);

  public execute(query: GetInvestigationAttachmentsQuery): Observable<GetInvestigationAttachmentsResult> {
    this._state.setLoadingAttachments(true);
    this._state.setErrorAttachments(null);
    return this._repository.getAttachments(query.investigationId).pipe(
      tap((attachments) => { this._state.setAttachments(attachments); this._state.setLoadingAttachments(false); }),
      map((attachments) => ({ attachments })),
      catchError((error) => { this._state.setErrorAttachments(error.message || 'Failed to load attachments'); this._state.setLoadingAttachments(false); return throwError(() => error); }),
    );
  }
}
